module.exports = __webpack_public_path__ + "static/wrow2-afdc4e9283a4f3e5d8209e032adb17c6.jpg";